import { useVerificationInputUpdate } from "../../../Logic/Functions/Hooks/useVerificationInputUpdate";
import {
  IVerificationInputProps,
  TextInputRefMapping,
} from "../../../Model/UIComponents.model";
import styles from "./UiLibraryComponent.module.css";

import React, { useEffect, useRef } from "react";

const VerificationInput: React.FC<IVerificationInputProps> = ({
  length,
  onChange,
  error,
  customContainerStyle,
  customErrorStyle,
  customInputStyle,
  type,
}) => {
  const inputsRefs = useRef<TextInputRefMapping>({});

  const { code, onKeyPress, handleChange, warning, handlePasteEvent } =
    useVerificationInputUpdate({
      inputsRefs,
      length,
      type,
    });

  useEffect(() => {
    const isComplete = code.every((char) => char.trim() !== "");
    onChange({ data: code, isComplete });
  }, [code]);

  return (
    <div className={styles.containerver}>
      <div
        className={`${styles.inputContainer} ${customContainerStyle}`}
        data-testid="verification_input_container"
      >
        <div className={styles.message}>
          <h3>Enter Verification code</h3>
        </div>
        <div
          className={styles.verificationContainer}
          data-testid="verification_input_wrapper"
        >
          {Array.from({ length }, (_, i) => (
            <input
              key={i}
              type="text"
              inputMode={type === "number" ? "numeric" : "text"}
              className={`${styles.verificationInput} ${customInputStyle} ${error ? styles.inputWithError : ""
                }`}
              value={code[i]}
              onKeyDown={(ev) => onKeyPress(ev, i)}
              onChange={(e) => handleChange(e.target.value, i)}
              onPaste={handlePasteEvent}
              ref={(el) => {
                inputsRefs.current[i] = el;
              }}
              data-testid={`verification_input_box_${i}`}
            />
          ))}
        </div>
      </div>

      <div className="margin-bottom-20 margin-top--10">
        {error && (
          <div
            className={`${styles.errorMessagever} ${customErrorStyle}`}
            data-testid="verification_input_error_message"
          >
            {error}
          </div>
        )}

        {warning && (
          <div
            className={styles.warningMessage}
            data-testid="verification_input_warning_message"
          >
            {warning}
          </div>
        )}
      </div>
    </div>
  );
};

export default VerificationInput;
